module.exports = __webpack_public_path__ + "static/nice-to-b1ea0b13dff26aada2ea2d67a65bdff1.svg";